import {AbstractAdvanceFilter} from './abstract-advance-filter';

export class DropdownAdvanceFilter extends AbstractAdvanceFilter {

    public getValueFromChange(event, param) {
        return event;
    }
}
